<template>
    <div>Stats</div>
</template>

<script>
export default {
    name: "Stats"
}
</script>

<style scoped>

</style>
